import Forbidden from '@/views/403.vue'

const routes = {
    path: '/:account_id/forbidden',
    name: 'forbidden',
    component: Forbidden
}

export default routes
